export enum ExportType {
  Timeslot = 'timeslot',
}
